module.exports = __webpack_public_path__ + "static/img/superhero_03_preview.ce97cb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/events/superhero_03_preview.png
// module id = 79oe
// module chunks = 0